import React, { Component } from 'react';
import { Layout, Menu, Icon, Button, Descriptions, Select} from 'antd';

const { Header, Content, Footer, Sider } = Layout;

const { Option } = Select;

class ReviewImages extends Component {

  handleChange = async(e, img, index) => {
    this.props.updateImage(e, img, index)
  }

  render() {
    return (
      <div>
        <h2>Review & Update Classification Predictions</h2>

        <div style={{ margin: 5, padding: 24, background: '#fff', display: 'flex', flexDirection: 'column'}}> 
          {this.props.imgArray.map((img, i) => {
            return (
              <div key={i} style={{display: 'flex', marginBottom: 12}}>
                <div style={{ margin: 5,}} >         
                  <img style={{ maxWidth: 400 }} src={img.src2} />
                </div>
                <div style={{ margin: 5,}} >
                  <div>
                    <p><b>Company:</b> {img.linkInfo && img.linkInfo.companyName}</p>
                    <p><b>Score:</b> {img.linkInfo.classifiedData && img.linkInfo.classifiedData.winningClass.prob}</p>
                    <p><b>Link:</b> {img.linkInfo.link && img.linkInfo.link}</p>
                    <Select 
                      defaultValue={img.linkInfo.classifiedData.updatedWinner ? img.linkInfo.classifiedData.updatedWinner : img.linkInfo.classifiedData.winningClass.label} 
                      style={{ width: 120, marginBottom: 12 }} 
                      onChange={(e) => this.handleChange(e, img, i)}
                    >   
                      {this.props.labels.map((label) => {
                        return (
                          <Option value={label}>{label}</Option> 
                        )
                      })}                    
                    </Select>  
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    );
  }
}

export default ReviewImages;